<template>
	<NuxtLayout
		name="standard"
		:menu-items="mainMenuItems()"
		page-title="Contact met Fit Hier"
		:breadcrumbs="breadcrumbs"
	>
		<div class="bg-gray-50 grow">
			<div
				class="container py-32 flex flex-col-reverse sm:flex-row gap-24 sm:gap-12 md:gap-24"
			>
				<div
					class="grow flex sm:flex-col md:flex-row gap-12 sm:pr-8 md:pr-0 sm:border-r-2 md:border-r-0 border-gray-200"
				>
					<div class="grow">
						<MoleculeContactBlock
							class="text-paragraph-size-md text-gray-700 md:border-l-2 border-gray-200 md:pl-12"
							:company-data="{
								...baseCompanyData,
								...fitCompanyData,
							}"
						/>
					</div>
					<div class="grow">
						<MoleculeOpeningHoursBlock
							class="text-paragraph-size-md text-gray-700 md:border-l-2 border-gray-200 md:pl-12"
							:opened-at="openingHoursFysio"
						/>
					</div>
				</div>
				<hr class="sm:hidden border-b">
				<div class="grow flex flex-col gap-12">
					<AtomTitle
						tag="h3"
						size="lg"
						class="text-purple-900"
					>
						Stuur een bericht
					</AtomTitle>
					<OrganismFormContact :form-spree-endpoint="FormSpreeFormsEnum.Contact" />
				</div>
			</div>
		</div>
	</NuxtLayout>
</template>

<script lang="ts" setup>
import * as baseCompanyData from '#base/core/consts/companyData';
import * as fitCompanyData from '#fit/core/consts/companyData';
import openingHoursFysio from '#base/core/consts/openingHoursFysio';
import type { FormName } from '#base/core/types/FormName';
import { FormSpreeFormsEnum } from '#fit/core/enums/FormSpreeFormsEnum';

const breadcrumbs = [
	{
		text: 'Home',
		to: {
			title: 'Home',
			url: '/',
		},
	},
	{
		text: 'Contact',
		to: {
			url: '/contact',
			title: 'Contact met Fit Hier',
		},
	},
];

useSeoMeta({
	title: 'Contact Fit Hier Uden - Adres, Openingstijden & Route',
	ogTitle: 'Contact Fit Hier – Route, Telefoon & Openingstijden',
	description: `Neem contact op met Fit Hier in Uden. Bel ${baseCompanyData.phoneNumber}, mail ${fitCompanyData.generalMail} of plan direct je proefles. Bekijk adres, route en ruime openingstijden.`,
});

const route = useRoute();
const activeForm = ref<FormName>((route.query.form as FormName) ?? 'contact');

watch(
	route,
	r => (activeForm.value = (r.query.form as FormName) ?? 'contact'),
	{
		immediate: true,
		deep: true,
	},
);
</script>
